































import Component from 'vue-class-component'
import { Prop, Vue } from 'vue-property-decorator'
import Zone from '@/dto/Zone/Zone'
import ZonesTableRow from '@/components/delivery/zones/ZonesTableRow.vue'
import ZonesTableHeader from '@/components/delivery/zones/ZonesTableHeader.vue'

@Component({
  components: { ZonesTableHeader, ZonesTableRow },
})
export default class ZonesTable extends Vue {
  @Prop(Array)
  zones: Zone[]

  queryString: string = ''

  pagination = {
    rowsPerPage: 1000,
  }

  columns = [
    {
      name: 'name',
      align: 'left',
      field: 'name',
      sortable: false,
    },
    {
      name: 'location',
      align: 'left',
      sortable: false,
    },
    {
      name: 'terms',
      align: 'left',
      sortable: false,
    },
    {
      name: 'actions',
      align: 'right',
      sortable: false,
    },
  ]

  get sortedZones(): Zone[] {
    return this.filteredZones
      .sort((a: Zone, b: Zone) => a.position - b.position)
      .slice()
  }

  get filteredZones(): Zone[] {
    if (!this.queryString) {
      return this.zones
    }

    return this.zones.filter(zone => {
      const inCountries = zone.items.some(item =>
        item.country.name.toLowerCase().includes(this.queryString.toLowerCase())
      )

      if (inCountries) {
        return true
      }

      const inRegions = zone.items
        .filter(item => !!item.state.name)
        .some(item =>
          item.state.name.toLowerCase().includes(this.queryString.toLowerCase())
        )

      if (inRegions) {
        return true
      }

      return zone.items.some(
        item =>
          !!item.city.name &&
          item.city.name.toLowerCase().includes(this.queryString.toLowerCase())
      )
    })
  }
}
